import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../helpers/utility';

const initialState = {
  error: null,
  loading: false,
  leadId: 0,
  crmFields: {},
  crmValues: {},
  leadFields: {},
  leadValues: {},
};

const getCustomerDetailsStart = (state, action) => {
  return updateObject(state, { loading: true });
};

const getCustomerDetailsSuccess = (state, action) => {
  if (action.leadType === 'passive') {
    return updateObject(state, {
      error: null,
      loading: false,
      leadFields: action.crmFields,
      leadValues: action.crmValues,
      // basicFields: action.basicFields,
      // basicValues: action.basicValues,
    });
  } else {
    return updateObject(state, {
      error: null,
      loading: false,
      crmFields: action.crmFields,
      crmValues: action.crmValues,
      // basicFields: action.basicFields,
      // basicValues: action.basicValues,
    });
  }
};

const getCustomerDetailsFail = (state, action) => {
  return updateObject(state, { error: action.error, loading: false });
};

//2. CRM Update
const customerDetailsStart = (state, action) => {
  return updateObject(state, { loading: true });
};

const customerDetailsSuccess = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: false,
  });
};

const customerDetailsFail = (state, action) => {
  return updateObject(state, { error: action.error, loading: false });
};

//2. create Customer
const createCustomerStart = (state, action) => {
  return updateObject(state, { loading: true });
};

const createCustomerSuccess = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: false,
    leadId: action.leadId,
  });
};

const resetCustomerDetails = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: false,
    leadId: 0,
    crmFields: {},
    crmValues: {},
    leadFields: {},
    leadValues: {},
  });
};


const createCustomerFail = (state, action) => {
  return updateObject(state, { error: action.error, loading: false });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CUSTOMER_DETAILS_START:
      return getCustomerDetailsStart(state, action);
    case actionTypes.GET_CUSTOMER_DETAILS_SUCCESS:
      return getCustomerDetailsSuccess(state, action);
    case actionTypes.GET_CUSTOMER_DETAILS_FAIL:
      return getCustomerDetailsFail(state, action);
      case actionTypes.RESET_CUSTOMER_DETAILS:
      return resetCustomerDetails(state, action);

    case actionTypes.CUSTOMER_DETAILS_START:
      return customerDetailsStart(state, action);
    case actionTypes.CUSTOMER_DETAILS_SUCCESS:
      return customerDetailsSuccess(state, action);
    case actionTypes.CUSTOMER_DETAILS_FAIL:
      return customerDetailsFail(state, action);

    case actionTypes.CREATE_CUSTOMER_START:
      return createCustomerStart(state, action);
    case actionTypes.CREATE_CUSTOMER_SUCCESS:
      return createCustomerSuccess(state, action);
    case actionTypes.CREATE_CUSTOMER_FAIL:
      return createCustomerFail(state, action);

    default:
      return state;
  }
};

export default reducer;
